import {releaseNotesService} from 'services';

export const FETCH_RELEASE_NOTES = 'FETCH_RELEASE_NOTES';
export const SET_RELEASE_NOTE = 'SET_RELEASE_NOTE';


const releaseNotesStore = {
  namespaced: true,
  state () {
    return {
      releaseNote: null
    };
  },
  getters: {
    releaseNoteIsSeen: (state, getters, rootState, rootGetters) => (releaseNote) => {
      const userNotes = rootGetters['user/userReleaseNotes'];

      if (!releaseNote) {
        return false;
      }

      return Boolean(userNotes[releaseNote.id] && userNotes[releaseNote.id].seen);
    },
    onboardingIsSeen: (state, getters, rootState, rootGetters) => (onboardingId) => {
      const userOnboardings = rootGetters['user/userOnboardings'];

      if (!onboardingId) {
        return false;
      }

      return Boolean(userOnboardings[onboardingId] && userOnboardings[onboardingId].seen);
    },
    newFeatureMarkerSeen: (state, getters, rootState, rootGetters) => markerId => {
      const userMarkers = rootGetters['user/userNewFeatureMarks'];

      return Boolean(userMarkers[markerId] && userMarkers[markerId].seen);
    },
    lastReleaseNote: state => state.releaseNote,
    releaseNoteToShow (state, getters) {
      const note = getters.lastReleaseNote;
      return getters.releaseNoteIsSeen(note) ? false : note;
    },
    onboardingToShow (state, getters) {
      const note = getters.lastReleaseNote;

      if (!getters.releaseNoteIsSeen(note) || note.content.action !== 'SHOW_ONBOARDING') {
        return false;
      }

      const onboardingId = note.content.params.id;
      return getters.onboardingIsSeen(onboardingId) ? false : onboardingId;
    }
  },
  mutations: {
    [SET_RELEASE_NOTE] (state, note) {
      state.releaseNote = note;
    }
  },
  actions: {
    async [FETCH_RELEASE_NOTES] (context) {
      const releaseNotes = (
        await releaseNotesService.getList(1, '-id', {hideError: true})
      ).items;
      if (releaseNotes.length === 0) {
        return;
      }
      context.commit(SET_RELEASE_NOTE, releaseNotes[0]);
    }
  }
};

export default releaseNotesStore;
